import React from "react";
import SEOHead from "../components/SEOHead";
import Header from "./Header";
import Footer from "./Footer";
import Hero from "./home/Hero";
import Brand from "./home/Brand";
import About from "./home/About";
import Process from "./home/Process";
import Service from "./home/Service";
import Feature from "./home/Feature";
import Testimonial from "./home/Testimonial";
import Cta from "./home/Cta";
import OgImage from "../assets/landing/img/hero/meta-open-graph-img.jpg";

const HomePage = () => {
  return (
    <>
      <SEOHead pageKey="home" />
      <Header />
      <Hero />
      <Brand />
      <About />
      <Process />
      <Service />
      <Feature />
      <Testimonial />
      <Cta />
      <Footer />
    </>
  );
};

export default HomePage;
